export default {"src":"/_next/static/media/female.15a65cce.svg","height":67,"width":31,"blurWidth":0,"blurHeight":0};